module.exports = __webpack_public_path__ + "static/PatKT-02-834746c73d8ab6f5b3c89bf87a888064.jpg";